<template>
    <div style="text-align: left">
        <div class="list">学校列表</div>
        <div class="content">
            <div class="goods">
                <div style="width:100%">
                    所属区域：<el-cascader :options="options" @change="handleChange" @focus="getTree" v-model="schoolMap"
                        :props="{ value: 'id', label: 'areaName', children: 'childList' }" ref="cascaderAddr">
                    </el-cascader>
                    <!-- <el-button slot="append" icon="el-icon-search" @click="getSchool"></el-button> -->

                    &nbsp;&nbsp;&nbsp;学校名称：<el-input placeholder="请输入学校名称" class="input-with-select"
                        style="max-width: 300px;margin-right: 20px;" v-model.trim="queryList.schoolName"></el-input>
                    <el-button @click="getSchool" type="primary">搜 索</el-button>

                    <el-button @click="reset" style="margin-left: 20px" type="primary" plain>重置</el-button>
                    <hr style="margin-top: 20px" />
                    <div style="margin-top: 20px">
                        <el-button type="primary" plain @click="addSchool">新增学校</el-button>
                        <el-button type="primary" plain @click="fullBatch">全部批次</el-button>
                        <!-- <el-button type="primary" plain>批量删除</el-button> -->
                    </div>
                </div>
                <br />

            </div>
            <br />
            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange"
                    :cell-style="{}" header-align="center">
                    <!-- <el-table-column type="selection" width="55" align="center">
                </el-table-column> -->
                    <el-table-column type="index" width="50" label="序号" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="schoolName" label="学校名称" width="300" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="province" label="省份" header-align="center" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="city" label="城市" width="100" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="area" label="区域" width="100" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="address" label="详细地址" width="300" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
                            <el-button type="text" size="small" @click="editorChild(scope.row)">编辑</el-button>
                            <el-button @click="deleteGoodsOne(scope.row)" type="text" size="small">删除</el-button>
                            <!-- <el-button @click="addGrade(scope.row)" type="text" size="small">添加年级</el-button> -->
                            <el-button @click="studentManagement(scope.row)" type="text" size="small">学生管理</el-button>
                            <el-button type="text" size="small" @click="batchManagement(scope.row)">批次管理</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="queryList.pageNum" :page-size="queryList.pageSize"
                    layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>


        <!-- 新增学校表单 -->
        <el-dialog :title="ruleForm.id ? '编辑' : '新增'" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="学校名称" prop="schoolName">
                    <el-input v-model="ruleForm.schoolName"></el-input>
                </el-form-item>
                <el-form-item label="所属区域" prop="area">
                    <el-cascader :options="options1" @change="handleChange1" v-model="addSchoolMap"
                        :props="{ value: 'id', label: 'areaName', children: 'childList' }" ref="cascaderAddr1">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="学校地址" prop="address">
                    <el-input v-model="ruleForm.address"></el-input>
                </el-form-item>
                <el-form-item label="学校logo" prop="pictureUrl">
                    <!-- <el-input v-model="ruleForm.pictureUrl"></el-input> -->
                    <el-upload ref="upload" :headers="{ 'authorization': 'Bearer ' + this.authorization }"
                        accept=".png,.jpg" class="upload-demo" :action="url + 'admin/file/upload/else'" :on-success="logo"
                        :limit="1">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5M</div>
                    </el-upload>
                </el-form-item>
                <img class="logo" v-if="ruleForm.pictureUrl"
                    :src="`${ruleForm.pictureUrl}`" alt="logo">
                <el-form-item label="负责人" prop="chargePerson">
                    <el-input v-model="ruleForm.chargePerson"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <el-form-item label="是否为集团">
                    <!-- {{ isEducationGroupId }}----{{ ruleForm.educationGroupId }}----{{ ruleForm.partnerId }} -->
                    <el-switch v-model="isEducationGroupId" active-text="是" inactive-text="否" @change="isEdu">
                    </el-switch>
                </el-form-item>
                <el-form-item label="集团名称" :prop="(isEducationGroupId ? 'educationGroupId' : '')" v-if="isEducationGroupId">
                    <el-select v-model="ruleForm.educationGroupId" placeholder="请选择">
                        <el-option v-for="(item, index) in educationGroupId" :key="index" :label="item.areaName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="ruleForm.email"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" v-if="!ruleForm.id">添 加</el-button>
                <el-button type="primary" @click="submitForm1('ruleForm')" v-if="ruleForm.id">编 辑</el-button>
            </span>
        </el-dialog>

        <!-- <el-dialog :title="ruleForm.id ? '编辑' : '新增'" :visible.sync="dialogVisible" width="65%"
            :before-close="handleClose"> -->
        <!-- 年级班级 -->
        <el-dialog title="年级/班级" :visible.sync="dialogGrade" width="40%" :before-close="handleClose">
            <div v-for="(item, index) in gradeClass.arr" :key="index">
                <span class="classAdd">
                    <span>年级： <el-input v-model="item.grade" style="width:100px"></el-input></span>
                    <span>班级： <el-input v-model="gradeClass.arrClass[index]" @blur="classList(index)" style="width:100px"
                            onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                        <!-- {{ gradeClass.arr[index].classAddListDto.length }} -->
                        <el-button @click="removeGrade(item)" type="danger">删除</el-button>
                    </span>
                </span>
            </div>
            <div style="display:flex;justify-content: space-between;">
                <el-button @click="addClass" type="primary" plain>添加</el-button>
                <div>
                    <el-button @click="cancelClass">取消</el-button>
                    <el-button @click="addGradeClass" type="primary">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import request from '../utils/request';
import url from '../Api/imagesUrl';
export default {
    data() {
        return {
            url,
            authorization: '',
            tableData: [],
            options: [],
            options1: [],
            queryList: {
                pageNum: 1,
                pageSize: 10,
                area: '',
                city: '',
                province: '',
                educationGroupId: '',
                idPage: true,
                schoolName: ''
            },
            total: 0,
            schoolMap: [],
            dialogVisible: false,
            ruleForm: {
                address: '',
                area: '',
                chargePerson: '',
                city: '',
                educationGroupId: '',
                email: '',
                id: '',
                partnerId: '',
                phone: '',
                province: '',
                schoolCode: '',
                schoolName: '',
                pictureUrl: ''
            },
            addSchoolMap: '',
            rules: {
                schoolName: [
                    { required: true, message: '请输入学校名称', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                area: [
                    { required: true, message: '请选择所属区域', trigger: 'blur' },
                ],
                address: [
                    { required: true, message: '请输入学校地址详细地址', trigger: 'blur' },
                ],
                chargePerson: [
                    { required: true, message: '请输入负责人姓名', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    {
                        pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'blur'
                    }
                ],
                educationGroupId: [
                    { required: true, message: '请选择教育集团', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请选择教育集团', trigger: 'blur' },
                    {
                        pattern: /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/,
                        message: '请输入正确的邮箱',
                        trigger: 'blur'
                    }
                ],
                pictureUrl: [
                    { required: true, message: '请上传学校logo', trigger: 'blur' },
                ],
            },
            // 教育集团数据
            educationGroupId: [],
            // 省市区数据
            partnerId: [],
            isEducationGroupId: false,
            // 年级班级弹窗显示隐藏
            dialogGrade: false,
            // 年级班级数组
            gradeClass: {
                arr: [
                    // {
                    //     classAddListDto: [
                    //     ],
                    //     grade: "string",
                    //     schoolId: 0
                    // },
                    // {
                    //     classAddListDto: [
                    //         { classWame: '1班' }
                    //     ],
                    //     grade: "123",
                    //     schoolId: 0
                    // }
                ],
                arrClass: []
            },
            schoolId: ''
        };
    },
    // 路由跳转
    beforeRouteLeave(to, from, next) {
        //console.log('路由离开之前', to, from,);
        //console.log(to.name === 'detailsGoods');
        if (to.name === 'studentManagement') {
            from.meta.keepAlive = true
        } else if (to.name === 'batchManagement') {
            from.meta.keepAlive = true
        } else {
            from.meta.keepAlive = false
        }
        //console.log(from.$router, '121');
        next()
    },
    methods: {
        fullBatch() {
            this.$router.push({ name: 'fullBatch' })
        },
        handleClick(val) {
            this.$router.push({ name: 'campusDetails', query: { id: val.id } })
        },
        // 多选
        handleSelectionChange() {

        },
        //学校查询
        async getSchool() {
            const res = await request({
                method: "POST",
                url: 'admin/school/list',
                data: this.queryList
            })
            //console.log(res);
            if (res.code === '200') {
                this.tableData = res.data && res.data.list
                this.total = res.data && res.data.total
            } else {
                this.$message.error(res.message)
            }
        },
        //新增学校
        async addSchool() {
            this.dialogVisible = true
            this.resetSchool()
            // const res = await request({
            //     method: "POST",
            //     url: "/admin/school/add",
            //     data: 
            // })
            // //console.log(res);
        },
        // 查询省市区的树
        async getTree() {
            const res = await request({
                method: "POST",
                url: 'admin/school/tree'
            })
            //console.log(res);
            if (res.code === '200') {
                // this.options = res.data 
                this.setTree(res.data)
            } else {
                this.$message.error(res.message)
            }

        },
        // 查询省市区的树的数据处理
        setTree(data) {
            data.forEach(val => {
                // //console.log(val);
                // //console.log('aaaaaaa',val.childList != '');
                if (val.childList != '') {
                    val.childList.forEach(h => {
                        // //console.log('fei', h);
                        if (h.childList != '') {
                            h.childList.forEach(v => {
                                // //console.log('vv', v);
                                if (v.childList != '') {
                                    h.childList.forEach(t => {
                                        // //console.log('tt', t);
                                        t.childList = undefined
                                    })
                                } else {
                                    v.childList = undefined
                                }
                            })
                        } else {
                            h.childList = undefined
                        }
                    })
                } else {
                    // //console.log('val', val);
                    val.childList = undefined
                }
            });
            this.options = data
        },
        // 选择省市区
        handleChange(value) {
            // //console.log('val', value[0]);
            let thsAreaCode = this.$refs['cascaderAddr'].getCheckedNodes()[0]  // 获取label值
            //console.log(thsAreaCode.pathLabels);
            let address = thsAreaCode && thsAreaCode.pathLabels
            //console.log(address[0]);
            if (address[0] === "教育集团") {
                this.queryList.area = ''
                this.queryList.city = ''
                this.queryList.province = ''
                this.queryList.educationGroupId = value[0]
            } else {
                //console.log(address);
                this.queryList.area = address[2]
                this.queryList.city = address[1]
                this.queryList.province = address[0]
                this.queryList.educationGroupId = ''
            }
        },
        // 重置
        reset() {
            this.queryList.area = ''
            this.queryList.city = ''
            this.queryList.province = ''
            this.queryList.educationGroupId = ''
            this.queryList.schoolName = ''
            this.queryList.pageNum = 1
            this.queryList.pageSize = 10
            this.schoolMap = []
            this.getSchool()
        },
        // 查询省市区的树（添加学校）
        async getTree1() {
            const res = await request({
                method: "POST",
                url: '/admin/school/tree'
            })
            //console.log(res);
            if (res.code === '200') {
                // this.options = res.data 
                this.setTree1(res.data)
            } else {
                this.$message.error(res.message)
            }

        },
        // 查询省市区的树的数据处理（添加学校）
        setTree1(data) {
            let arr = []
            data.forEach((val, index) => {
                //console.log(val);
                // //console.log('aaaaaaa',val.childList != '');
                if (val.areaType != "集团") {
                    if (val.childList != '') {
                        val.childList.forEach(h => {
                            // //console.log('fei', h);
                            if (h.childList != '') {
                                h.childList.forEach(v => {
                                    // //console.log('vv', v);
                                    if (v.childList != '') {
                                        h.childList.forEach(t => {
                                            // //console.log('tt', t);
                                            t.childList = undefined
                                        })
                                    } else {
                                        v.childList = undefined
                                    }
                                })
                            } else {
                                h.childList = undefined
                            }
                        })
                    } else {
                        // //console.log('val', val);
                        val.childList = undefined
                    }
                } else {
                    arr.push(val)
                    data.splice(index, 1)
                    //console.log(this.educationGroupId);
                    // //console.log(val,index,'val1');
                    // val = undefined
                    // //console.log(val,'val1');
                }

            });
            this.educationGroupId = arr
            this.options1 = data
        },
        // 选择省市区 （添加学校）
        handleChange1(value) {
            // //console.log('val', value[0]);
            let thsAreaCode = this.$refs['cascaderAddr1'].getCheckedNodes()[0]  // 获取label值
            //console.log(thsAreaCode.pathLabels);
            let address = thsAreaCode && thsAreaCode.pathLabels
            //console.log(address, value);
            this.partnerId = value
            this.ruleForm.area = address[2]
            this.ruleForm.city = address[1]
            this.ruleForm.province = address[0]
            this.ruleForm.partnerId = [...value].pop()//value[2]
        },
        // 是否为集团的设置
        isEdu(e) {
            //console.log(e);
            if (e) {
                this.ruleForm.partnerId = ''
            } else {
                this.ruleForm.educationGroupId = ''
                //console.log(this.ruleForm.partnerId);
                this.ruleForm.partnerId = [...this.partnerId].pop()
            }
        },
        //表单验证
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.dialogVisible = false
                    const res = await request({
                        method: 'POST',
                        url: 'admin/school/add',
                        data: this.ruleForm
                    })
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.reset()
                        this.resetForm()
                        this.getSchool()
                    } else {
                        this.$message.error(res.message)
                    }
                    //console.log(res);
                } else {
                    //console.log('error submit!!');
                    return false;
                }
            });
        },
        // 编辑学校信息
        submitForm1(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.dialogVisible = false
                    const res = await request({
                        method: 'POST',
                        url: 'admin/school/update',
                        data: this.ruleForm
                    })
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.reset()
                        this.resetForm()
                        this.getSchool()
                    } else {
                        this.$message.error(res.message)
                    }
                    //console.log(res);
                } else {
                    //console.log('error submit!!');
                    return false;
                }
            });
        },
        // 重置新增学校数据
        resetSchool() {
            this.ruleForm.address = ''
            this.ruleForm.area = ''
            this.ruleForm.chargePerson = ''
            this.ruleForm.city = ''
            this.ruleForm.educationGroupId = ''
            this.ruleForm.email = ''
            this.ruleForm.id = ''
            this.ruleForm.partnerId = ''
            this.ruleForm.phone = ''
            this.ruleForm.province = ''
            this.ruleForm.schoolCode = ''
            this.ruleForm.schoolName = ''
            this.ruleForm.pictureUrl = ''
            this.isEducationGroupId = false
            this.addSchoolMap = ''
        },
        //   重置表单
        resetForm(formName) {
            this.dialogVisible = false
            this.$refs[formName].resetFields();
        },
        // 分页器
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        // 分页器
        handleCurrentChange() {
            // //console.log(`当前页: ${val}`);
            this.getSchool()
        },
        //编辑单个学校查询
        async editorChild(val) {
            //console.log(val);
            this.dialogVisible = true
            const res = await request({
                method: "GET",
                url: `admin/school/select?schoolId=${val.id}`,
            })
            //console.log(res);
            if (res.code === '200') {
                // this.$message.success(res.message)
                //console.log('111111111', res.data.area);

                this.options1.forEach(val => {
                    // //console.log(val);
                    if (val.areaName === res.data.area) {
                        this.addSchoolMap = val.id
                        return
                    } else {
                        val.childList.forEach(h => {
                            // //console.log(h);
                            if (h.areaName === res.data.area) {
                                this.addSchoolMap = h.id
                                return
                            } else {
                                h.childList.forEach(v => {
                                    // //console.log(v);
                                    if (v.areaName === res.data.area) {
                                        this.addSchoolMap = v.id
                                        this.partnerId.push(v.id)
                                        return
                                    }
                                })
                            }
                        })
                    }
                })
                if (res.data && res.data.educationGroupId == null) {
                    // let index = res.data.pictureUrl.indexOf('file')
                    // let picture = res.data.pictureUrl.slice(index + 4)
                    let picture = res.data.pictureUrl
                    res.data.pictureUrl = picture
                    //console.log('res', res.data);
                    this.ruleForm = res.data
                } else {
                    this.isEducationGroupId = true
                    // let index = res.data.pictureUrl.indexOf('file')
                    // let picture = res.data.pictureUrl.slice(index + 4)
                    let picture = res.data.pictureUrl
                    res.data.pictureUrl = picture

                    this.ruleForm = res.data
                }
            } else {
                this.$message.error(res.message)
            }
        },
        // 删除
        deleteGoodsOne(val) {
            //console.log(val.id);
            this.$confirm('确认删除？')
                .then(async () => {
                    // done();
                    const res = await request({
                        method: 'GET',
                        url: `admin/school/remove?school=${val.id}`
                    })
                    if (res.code === '200') {
                        this.$message.success(res.message)
                        this.getSchool()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(() => { });

            // //console.log(res);
        },
        // 是否关闭弹窗
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    done();
                })
                .catch(() => { });
        },
        // 添加年级班级弹窗
        async addGrade(val) {
            this.gradeClass.arr = []
            this.dialogGrade = true
            this.schoolId = val.id
            //console.log(val);
            const res = await request({
                method: 'GET',
                url: `admin/school/select/grade/class?schoolId=${val.id}`
            })
            if (res.code === '200') {
                // this.gradeClass.arr = res.data
                let arr = []
                res.data.forEach(v => {
                    v.schoolId = val.id
                    arr.push(v.classAddListDto.length)
                })
                this.gradeClass.arrClass = arr
                this.gradeClass.arr = res.data
            } else {
                this.$message.error(res.message)
            }
            //console.log(res);
        },
        // 遍历班级
        classList(index) {
            let arr = []
            for (let i = 0; i < this.gradeClass.arrClass[index]; i++) {
                arr.push({
                    className: `${i + 1}班`
                })
                this.gradeClass.arr[index].classAddListDto = arr
            }
        },
        // 添加班级
        addClass() {
            this.gradeClass.arr.push({
                classAddListDto: [
                ],
                grade: '',
                schoolId: this.schoolId
            })
        },
        // 删除年级
        removeGrade(item) {
            //console.log(item);
            let index = this.gradeClass.arr.indexOf(item)
            //console.log('arr', this.gradeClass.arr);
            //console.log(index);
            // this.gradeClass.arr.splice(index, 1)
            if (index !== -1) {
                this.gradeClass.arr.splice(index, 1)
            }
        },
        // 添加年级班级
        async addGradeClass() {

            if (this.gradeClass.arr.length !== 0) {
                this.dialogGrade = false
                const res = await request({
                    method: 'POST',
                    url: '/admin/school/edit/grade/class',
                    data: this.gradeClass.arr
                })
                //console.log(res);
                if (res.code === '200') {
                    this.$message.success(res.message)
                } else {
                    this.$message.error(res.message)
                }
            } else {
                this.$message.error('请添加班级年级')
            }
        },
        // 取消添加年级班级
        cancelClass() {
            this.dialogGrade = false
            this.gradeClass.arr = []
        },
        // 批次管理
        batchManagement(val) {
            //console.log(val.id);
            this.$router.push({ name: 'batchManagement', query: { id: val.id } })
        },
        // 学校logo上传
        logo(res) {
            //console.log(res);
            if (res.code === '200') {
                //console.log('file', res.data);
                // let index = res.data.indexOf('file')
                // let picture = res.data.slice(index + 4)
                this.ruleForm.pictureUrl = res.data
                this.$refs.upload.clearFiles()
            } else {
                this.$refs.upload.clearFiles()
                this.$message.error(res.message)
            }
        },
        // 跳转学生管理
        studentManagement(res) {
            //console.log(res);
            this.$router.push({
                name: 'studentManagement',
                query: {
                    id: res.id,
                    schoolName: res.schoolName
                }
            })
        },
    },


    components: {

    },
    created() {
        // console.log(url + 'admin/file/upload/else');
        this.getSchool()
        this.getTree()
        this.getTree1()
        this.authorization = sessionStorage.getItem('authorization')
    }
};
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
}

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}

.block {
    text-align: right;
    background-color: #fff;

}

.classAdd {
    margin-bottom: 10px;
    background-color: pick;
    display: block;

    span {
        margin-right: 20px;

        .el-button {
            margin-left: 20px;
        }
    }
}

.logo {
    width: 100px;
    height: 100px;
    position: relative;
    left: 100px;
}
</style>